module.exports = __webpack_public_path__ + "static/media/landing.f8fba454.jpg";